import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {SignInComponent} from './sign-in/sign-in.component';
import {auth_routing} from './auth.routing';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {LicenceComponent} from './licence/licence.component';
import {ChangePasswordComponent} from '../shared/change-password/change-password.component';
import {ForgotPasswordSubmitComponent} from './forgot-password/forgot-password-submit.component';
import {ChangePasswordSubmitComponent} from '../shared/change-password/change-password-submit.component';
import {SharedModule} from '../shared/shared.module';
import {AuthGuard} from './auth.guard';

@NgModule({
  declarations: [
    SignInComponent,
    ForgotPasswordComponent,
    ForgotPasswordSubmitComponent,
    LicenceComponent,
    // ChangePasswordComponent,
    ChangePasswordSubmitComponent

  ],
  imports: [
    CommonModule,
    auth_routing,
    FormsModule,
    // SharedModule
    SharedModule.forRoot()
  ],
  providers: [
    AuthGuard
  ],
  exports: [
    LicenceComponent,
    SignInComponent,
    ForgotPasswordComponent,
    ForgotPasswordSubmitComponent,
    // ChangePasswordComponent,
    ChangePasswordSubmitComponent

  ]
})
export class AuthModule {}
